<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "pompUsername":"wangdl",
              "path": "authz/parking_group",
              "hiddenMenu": true
           },
            responseCode: {"data":{
                "authLoginUrl": "http://172.18.30.5:5002/mgr/normal/ajax/mockLogin.do?loginId=wangdl&key=8c86157f9d7f009743243ed50fbadc19&from=YDTO"
            },"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "通过此接口可不输入密码登陆POMP",
                t_url: this.commonUrls.test+"automaticLoginPOMP",
                p_url: this.commonUrls.prod+"automaticLoginPOMP",
                precondition: "授权商拥有的车场权限必须全包含POMP账号的车场权限，否则返回“车场权限不足”",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'pompUsername', info2: '是', info3: 'String', info4: 'pomp登陆账号' },
                        { info1: 'path', info2: '否', info3: 'String', info4: '自动登录后跳转页面' },
                        { info1: 'hiddenMenu', info2: '否', info3: 'Boolean', info4: '是否隐藏菜单，默认false' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'authLoginUrl', info2: '是', info3: 'String', info4: '授权登陆地址' },
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/other/automaticLoginPOMP.vue